<section class="export">
  <div class="mdc-layout-grid">
    <div class="mdc-layout-grid__inner">
      <div
        class="mdc-layout-grid__cell mdc-layout-grid__cell--span-5-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
        <div class="export__action">
          @if ((status$ | async) === 'identified') {
          <ng-container *ngrxLet="meta$ | async as meta">
            <mat-icon class="export--center">download_for_offline</mat-icon>
            <h1 class="mat-headline-4 export--center" i18n="@@featureExport-headline-download"
              >Ihr Download steht ab jetzt für Sie bereit.</h1
            >
            <div class="export__file">
              <span class="export__filename">{{ meta?.name ?? metaNamePlaceholder }}</span>
              <span class="export__meta"
                >1 Datei - {{ meta?.size ?? 0 | HumanReadableFilesize : true }} - Typ: Excel</span
              >
            </div>
            <button
              class="export__button"
              mat-flat-button
              color="primary"
              i18n="@@featureExport-action-download"
              (click)="download(meta?.name ?? undefined)"
              >Herunterladen</button
            >
          </ng-container>
          } @else { @if ((status$ | async) === 'failed') {
          <mat-icon class="export--center">delete_history</mat-icon>
          <h1 class="mat-headline-4 export--center" i18n="@@featureExport-headline-expired">Downloadlink abgelaufen</h1>
          <p i18n="@@featureExport-content-text1">Die Datei steht nicht länger zur Verfügung.</p>
          <p i18n="@@featureExport-content-text2"
            >Kontaktieren Sie den Absender und bitten Sie um erneutes Teilen der Datei.</p
          >
          } @else {
          <div class="export__loading-animation">
            <planone-loading-animation></planone-loading-animation>
          </div>
          }
          <ng-template #loading>
            <div class="export__loading-animation">
              <planone-loading-animation></planone-loading-animation>
            </div>
          </ng-template>
          }
        </div>
      </div>
      <div
        class="mdc-layout-grid__cell mdc-layout-grid__cell--span-5-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone mdc-layout-grid__cell--start-7-desktop export__sub">
        <p i18n="@@featureExport-sub-teaser">...das können Sie sich merken:</p>
        <h2 class="mat-headline-3" i18n="@@featureExport-sub-headline"
          >Mit BAU INSIGHTS die Vielfalt der Baubranche <span>individuell erleben</span> und mit anderen teilen!</h2
        >
        <div>
          <a
            [routerLink]="['/fairs', '229', 'search']"
            target="_blank"
            class="export__button--discover"
            mat-stroked-button
            color="primary"
            i18n="@@featureExport-action-discover"
            >Jetzt entdecken</a
          >
        </div>
      </div>
    </div>
  </div>
</section>
